import React, { useState } from 'react';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import RuleTabSidePanel from './RuleTabSidePanel';

import * as classes from './RuleTab.module.css';

const font = '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';

const RuleTab = ({
    ...props
}) => {
    const [tabIndex, setTabIndex] = useState(0);

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const renderListPanel = index => {
        if (index === 0) {
            return <div style={{padding: '2rem'}}>Attachments & Notes</div>;
        } else if (index === 1) {
            return <div style={{ padding: '2rem' }}>Service</div>;
        } else if (index === 2) {
            return <div style={{ padding: '2rem' }}>Energy</div>;
        }
    };

    return (
        <div className={classes.RuleTab}>
            <RuleTabSidePanel />
            <div className={classes.RightPanel}>
                <Tabs
                    TabIndicatorProps={{ style: { background: 'black' } }}
                    value={tabIndex}
                    onChange={handleChange}
                >
                    <Tab value={0} style={{ width: '15rem', minWidth: '5rem', textTransform: 'none', fontFamily: font, fontSize: '1.2rem' }} label="Attachments & Notes" />
                    <Tab value={1} style={{ width: '8rem', minWidth: '5rem', textTransform: 'none', fontFamily: font, fontSize: '1.2rem' }} label="Service" />
                    <Tab value={2} style={{ width: '7rem', minWidth: '5rem', textTransform: 'none', fontFamily: font, fontSize: '1.2rem' }} label="Energy" />
                </Tabs>
                <div>
                    {renderListPanel(tabIndex)}
                </div>
            </div>
        </div>
    );
};

export default RuleTab;
